import React from "react";
import { withRouter } from "react-router";
import { ADD_ELEMENT, API_HOST, REMOVE_ELEMENT } from "../../utils/constants";

import {
  PageHeaderWrapperStyle,
  GridContainerStyle,
  LoadingStyle,
} from "../../utils/style-utils";
import {
  BackStyle,
  ListRowStyle,
  ListColStyle,
  FilterWrapperStyle,
  CatalogueLink,
  OrderContainerStyle,
  OrderHeaderStyle,
  OrderNameStyle,
  OrderCodeStyle,
  CardContainer,
  OrderToolbarStyle,
  OrderFooterStyle,
  NoteTitleStyle,
  NotesStyle,
  NoteTextStyle,
} from "./style";
import {
  Panel,
  StatusTag,
  PdfIcon,
  CartToolbar,
  AddressCard,
  Button,
  Modal,
  Message,
  Spinner,
} from "dab-component-lib";
import OldOrderDetailProduct from "../oldOrderDetailProduct/index";
import I18n from "../../I18n/I18n";
import { connect } from "react-redux";
import { compose, graphql } from "react-apollo";
import {
  createNodeCartLineItem,
  createNodeCartLineItemWithSizes,
  currencyById,
  currentUserCart,
  deleteNodeCartLineItem,
  getText,
  productByCode,
} from "../../queries";
import axios from "axios";

class OldOrderDetail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      offset: 0,
      rows: 10,
      currentPage: 1,
      loading: false,
      tableRows: [],
      count: 0,
      info: false,
      error: false,
      errorId: "",
      purchased: false,
      isEmptyCart: true,
      case: 1,
      products: [],
      notAvailable: [],
      availableProducts: [],
      reset: false,
    };
  }

  closeInfoCartModal = () => {
    this.setState({ info: false });
  };

  createNodeCartLineItem = async (targetIdProduct, quantity, size) => {
    const {
      createNodeCartLineItem,
      createNodeCartLineItemWithSizes,
    } = this.props;
    let result = [];
    if (size) {
      result = await createNodeCartLineItemWithSizes({
        variables: {
          title: `user: ${localStorage.getItem(
            "currentUid"
          )} + product: ${targetIdProduct}`,
          targetIdProduct,
          quantity: quantity.toString(),
          size,
        },
      });
    } else {
      result = await createNodeCartLineItem({
        variables: {
          title: `user: ${localStorage.getItem(
            "currentUid"
          )} + product: ${targetIdProduct}`,
          targetIdProduct,
          quantity: quantity.toString(),
        },
      });
    }
    return result;
  };

  sendAvailableProduct = () => {
    this.setState({ loading: true });
    this.state.availableProducts.forEach(async (item) => {
      let nidObject = await this.createNodeCartLineItem(
        item.id,
        item.quantity,
        false
      );
      let nid = nidObject.data.createNodeCartLineItem.entity.nid;
      let currencyName = this.props.currencyById.nodeById.fieldCurrencyName;
      let uid = localStorage.getItem("currentUid");
      let res = {};
      if (
        !this.props.currentUserCart.error &&
        !this.props.currentUserCart.loading &&
        this.props.currentUserCart.currentusercartGraphql1View.results.length <
          1
      ) {
        res = await axios.get(
          `${ADD_ELEMENT}/create/${nid}/${currencyName}/${uid}`
        );
      } else {
        let cartId = this.props.currentUserCart.currentusercartGraphql1View
          .results[0].id;
        res = await axios.get(
          `${ADD_ELEMENT}/${cartId}/${nid}/${currencyName}/${uid}`
        );
      }
      if (res.data.status === 1) {
        this.props.currentUserCart.refetch();
        this.setState({ purchased: true });
      } else {
        this.setState({ error: true, errorId: item.id });
      }
    });
    this.props.history.push("/checkout");
  };

  addProductToCart = async (products, cart = false) => {
    let results;
    let avaibleProducts = [];
    let checkArray = [];
    let fin = false;

    // Little delay to fix "deadlock" issue with multiple refetch
    const delay = (ms) => new Promise((res) => setTimeout(res, ms));

    for (let index = 0; index < products.length; index++) {
      results = await this.props.productByCode.refetch({
        code: products[index].item,
      });

      // Await delay to avoid overwhelming the server
      await delay(500);

      if (results.data.productcodeGraphql1View !== undefined) {
        let res = results.data.productcodeGraphql1View.results[0];

        // richiesta
        let availability =
          res && res.fieldAvailability ? res.fieldAvailability : 0;
        //quantità
        let max =
          res && res.fieldMaxShopQuantity ? res.fieldMaxShopQuantity : 0;

        let id = res && res.entityId ? res.entityId : null;
        // Quntità del prodotto da ricomprare
        let quantity = products[index].quantity;

        if (quantity >= availability || quantity >= max) {
          //if (index === 1) {
          checkArray.push(products[index]);
        } else {
          avaibleProducts.push({ ...products[index], id: id });
        }
      }

      if (index === products.length - 1) {
        fin = true;
      }
    }
    if (checkArray.length === 0) {
      for (const item of avaibleProducts) {
        let nidObject = await this.createNodeCartLineItem(
          item.id,
          item.quantity,
          false
        );
        let nid = nidObject.data.createNodeCartLineItem.entity.nid;
        let currencyName = this.props.currencyById.nodeById.fieldCurrencyName;
        let uid = localStorage.getItem("currentUid");
        let res = {};
        if (
          !this.props.currentUserCart.error &&
          !this.props.currentUserCart.loading &&
          this.props.currentUserCart.currentusercartGraphql1View.results
            .length < 1
        ) {
          res = await axios.get(
            `${ADD_ELEMENT}/create/${nid}/${currencyName}/${uid}`
          );
        } else {
          let cartId = this.props.currentUserCart.currentusercartGraphql1View
            .results[0].id;
          res = await axios.get(
            `${ADD_ELEMENT}/${cartId}/${nid}/${currencyName}/${uid}`
          );
        }
        if (res.data.status === 1) {
          this.props.currentUserCart.refetch();
          this.setState({ purchased: true });
        } else {
          this.setState({ error: true, errorId: item.id });
        }
      }
      // avaibleProducts.forEach(async (item) => {
      //   let nidObject = await this.createNodeCartLineItem(
      //     item.id,
      //     item.quantity,
      //     false
      //   );
      //   let nid = nidObject.data.createNodeCartLineItem.entity.nid;
      //   let currencyName = this.props.currencyById.nodeById.fieldCurrencyName;
      //   let uid = localStorage.getItem("currentUid");
      //   let res = {};
      //   if (
      //     !this.props.currentUserCart.error &&
      //     !this.props.currentUserCart.loading &&
      //     this.props.currentUserCart.currentusercartGraphql1View.results
      //       .length < 1
      //   ) {
      //     res = await axios.get(
      //       `${ADD_ELEMENT}/create/${nid}/${currencyName}/${uid}`
      //     );
      //   } else {
      //     let cartId = this.props.currentUserCart.currentusercartGraphql1View
      //       .results[0].id;
      //     res = await axios.get(
      //       `${ADD_ELEMENT}/${cartId}/${nid}/${currencyName}/${uid}`
      //     );
      //   }
      //   if (res.data.status === 1) {
      //     this.props.currentUserCart.refetch();
      //     this.setState({ purchased: true });
      //   } else {
      //     this.setState({ error: true, errorId: item.id });
      //   }
      // });
    } else {
      return this.setState({
        loading: false,
        info: true,
        case: 4,
        notAvailable: checkArray,
        availableProducts: avaibleProducts,
      });
    }

    fin &&
      (cart
        ? this.props.history.push("/checkout", "test")
        : this.setState({ loading: false, info: true, case: 2 }));
  };

  openModal = (products) => {
    if (this.getEmptyCart() && this.state.case === 1) {
      this.setState({ loading: true, case: 1 });
      this.addProductToCart(products);
    } else {
      this.setState({
        loading: false,
        info: true,
        case: 3,
        products: products,
      });
    }
  };

  getTitleModal = (caseState) => {
    if (caseState === 2 || caseState === 1) {
      return {
        0: I18n.t("modals.orderRepeatModal.emptyCart.title"),
        1: I18n.t("modals.orderRepeatModal.emptyCart.button1"),
        2: I18n.t("modals.orderRepeatModal.emptyCart.button2"),
      };
    } else if (caseState === 3) {
      return {
        0: I18n.t("modals.orderRepeatModal.notEmptyCart.title"),
        1: I18n.t("modals.orderRepeatModal.notEmptyCart.button1"),
        2: I18n.t("modals.orderRepeatModal.notEmptyCart.button2"),
        3: I18n.t("modals.orderRepeatModal.notEmptyCart.description"),
      };
    } else if (caseState === 4) {
      return {
        0: I18n.t("modals.orderRepeatModal.emptyCartCase4.title"),
        1: I18n.t("modals.orderRepeatModal.emptyCartCase4.button1"),
        2: I18n.t("modals.orderRepeatModal.emptyCartCase4.button2"),
        3: I18n.t("modals.orderRepeatModal.emptyCartCase4.description"),
      };
    }
  };

  resetCart = async (i = 0) => {
    const {
      currentUserCart: { loading, error, currentusercartGraphql1View, refetch },
    } = this.props;
    currentusercartGraphql1View.results.forEach((value) => {
      value.fieldLineItemsReference.forEach((item) => {
        let code = item.entity.fieldProductReference.entity.fieldCode;
        //cartQuantity.push(item.entity.fieldProductReference.entity.quantity)
        this.state.products.forEach((value) => {
          if (code === value.item) {
            value.quantity =
              value.quantity + item.entity.fieldProductReference.quantity;
          }
        });
      });
    });
    this.setState({ loading: true, info: false });
    let uid = localStorage.getItem("currentUid");
    if (!loading && !error) {
      let cart_id = currentusercartGraphql1View.results[0].id;
      currentusercartGraphql1View.results[0].fieldLineItemsReference.forEach(
        async (item) => {
          let id = item.targetId;
          await axios.get(`${REMOVE_ELEMENT}/${cart_id}/${id}/${uid}`);
          i++;
          await this.resetCart();
        }
      );
    }
    await refetch();
    i--;
  };

  goToCart = () => {
    this.props.history.push("/checkout");
  };

  getEmptyCart = () => {
    let emptyCart =
      this.props.currentUserCart.currentusercartGraphql1View !== undefined &&
      this.props.currentUserCart.currentusercartGraphql1View.results.length > 0 &&
      this.props.currentUserCart.currentusercartGraphql1View.results[0]
        .fieldLineItemsReference.length > 0
        ? false
        : true;
    return emptyCart;
  };

  renderProduct = (product, index) => {
    return (
      <CardContainer key={`product-${index}-${product.item}`}>
        <OldOrderDetailProduct product={product} editable={false} />
      </CardContainer>
    );
  };

  downloadCatalogue = (id) => {
    window.open(
      `${API_HOST}/${
        localStorage.getItem("language")
          ? localStorage.getItem("language")
          : "it"
      }/node/pdf/${id}/pdf_order?prices_enabled=${
        localStorage.getItem("showPrices") ? 1 : 0
      }`
    );
  };

  render() {
    const { history } = this.props;
    const {
      data: { calculated_data, remotedata, localstorage },
    } = this.props.location.state;

    if (this.state.loading) {
      return (
        <LoadingStyle>
          <Spinner size={150} />
        </LoadingStyle>
      );
    }
    if (
      this.state.reset === true &&
      this.props.currentUserCart.currentusercartGraphql1View !== undefined &&
      this.props.currentUserCart.currentusercartGraphql1View.results[0]
        .fieldLineItemsReference.length === 0
    ) {
      this.setState({ reset: false }, () =>
        this.addProductToCart(this.state.products, true)
      );
    }
    return (
      <GridContainerStyle>
        <PageHeaderWrapperStyle>
          <Modal
            open={this.state.info}
            handleClose={() => this.closeInfoCartModal()}
          >
            <div>
              <Message
                full={true}
                action={{
                  label: this.getTitleModal(this.state.case)[2],
                  onClick:
                    this.state.case === 2
                      ? () => this.goToCart()
                      : this.state.case === 4
                      ? () => this.sendAvailableProduct()
                      : () =>
                          this.setState({ reset: true }, () =>
                            this.resetCart()
                          ),
                }}
                actionSecondary={{
                  label: this.getTitleModal(this.state.case)[1],
                  onClick:
                    this.state.case === 2
                      ? () => this.closeInfoCartModal()
                      : () => this.closeInfoCartModal(),
                  outline: true,
                }}
                description={
                  !this.getEmptyCart()
                    ? this.getTitleModal(this.state.case)[3]
                    : this.state.case === 4
                    ? this.getTitleModal(this.state.case)[3]
                    : ""
                }
                title={this.getTitleModal(this.state.case)[0]}
              >
                {this.state.case === 4 &&
                  this.state.notAvailable.length > 0 &&
                  this.state.notAvailable.map((item) => {
                    return (
                      <p>
                        {" "}
                        <strong>
                          {" "}
                          - {item.item} - {item.item_description}{" "}
                        </strong>{" "}
                      </p>
                    );
                  })}
              </Message>
            </div>
          </Modal>
          <BackStyle onClick={() => history.goBack()}>
            {I18n.t("buttons.back")}
          </BackStyle>
        </PageHeaderWrapperStyle>
        <ListRowStyle>
          <ListColStyle quarter>
            <FilterWrapperStyle>
              <Panel title={calculated_data.order_code} size="M" skin="light">
                <div></div>
              </Panel>
            </FilterWrapperStyle>
            <Button
              icon="RepeatIcon"
              id="button_id"
              label={I18n.t("modals.orderRepeatModal.buttonDetail")}
              onClick={() => this.openModal(calculated_data.products)}
              size="M"
              expanded
            />
          </ListColStyle>
          <ListColStyle>
            <OrderContainerStyle>
              <OrderHeaderStyle>
                <OrderNameStyle>
                  <OrderCodeStyle>{calculated_data.order_code}</OrderCodeStyle>
                  <div>
                    <StatusTag
                      lang={
                        localStorage.getItem("language")
                          ? localStorage.getItem("language")
                          : "it"
                      }
                      status={calculated_data.readable_status}
                    />
                  </div>
                </OrderNameStyle>
                {calculated_data.readable_status !== "CANCELLED" &&
                  localstorage.nid.length > 0 &&
                  localstorage.nid[0].value && (
                    <CatalogueLink
                      onClick={() =>
                        this.downloadCatalogue(localstorage.nid[0].value)
                      }
                    >
                      <PdfIcon color="#004615" size={30} />{" "}
                      <span>{I18n.t("buttons.getOrderPdf")}</span>
                    </CatalogueLink>
                  )}
              </OrderHeaderStyle>
              <div>
                {calculated_data.products.map((product, i) => {
                  return this.renderProduct(product, i);
                })}
              </div>
              <OrderToolbarStyle>
                <CartToolbar
                  lang={
                    localStorage.getItem("language")
                      ? localStorage.getItem("language")
                      : "it"
                  }
                  currency="€"
                  totalItems={calculated_data.products.length}
                  totalPrice={parseFloat(remotedata.amount).toFixed(2)}
                />
              </OrderToolbarStyle>
              <OrderFooterStyle>
                <AddressCard
                  country={calculated_data.client_address.country_description}
                  email={calculated_data.client_address.mail}
                  name={calculated_data.client_address.name}
                  phone={calculated_data.client_address.telephone}
                  place={calculated_data.client_address.town_description}
                  street={`${calculated_data.client_address.street_address} ${calculated_data.client_address.street_address2}`}
                  zipCode={calculated_data.client_address.postal_code}
                />
                <NotesStyle>
                  <NoteTitleStyle>Note</NoteTitleStyle>
                  <NoteTextStyle>{remotedata.order_notes}</NoteTextStyle>
                </NotesStyle>
              </OrderFooterStyle>
            </OrderContainerStyle>
          </ListColStyle>
        </ListRowStyle>
      </GridContainerStyle>
    );
  }
}
export default connect()(
  compose(
    graphql(getText, {
      name: "getText",
      options: (props) => ({
        variables: {
          machineName: "user_orders",
          lang: localStorage.getItem("language")
            ? localStorage.getItem("language")
            : "it",
        },
      }),
    }),
    graphql(productByCode, {
      name: "productByCode",
      options: (code) => ({
        variables: {
          code: "60184428",
        },
      }),
    }),
    graphql(createNodeCartLineItem, {
      name: "createNodeCartLineItem",
    }),
    graphql(createNodeCartLineItemWithSizes, {
      name: "createNodeCartLineItemWithSizes",
    }),
    graphql(deleteNodeCartLineItem, {
      name: "deleteNodeCartLineItem",
    }),
    graphql(currentUserCart, {
      name: "currentUserCart",
      options: (props) => ({
        variables: {
          id: localStorage.getItem("currentUid"),
          lang: localStorage.getItem("language")
            ? localStorage.getItem("language")
            : "it",
        },
      }),
    }),
    graphql(currencyById, {
      name: "currencyById",
      options: (props) => ({
        variables: {
          id: localStorage.getItem("currency")
            ? localStorage.getItem("currency")
            : localStorage.getItem("defaultCurrency"),
        },
      }),
    })
  )(withRouter(OldOrderDetail))
);



// WEBPACK FOOTER //
// ./src/components/oldOrderDetail/index.js